<template>
  <div class="dialog-window">
    <el-row>
      <el-col :span="4">
        <div class="title">分组</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.group" size='mini' placeholder="请选择" @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of resData.groupMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="title">客户类型</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.agencyType" size='mini' placeholder="请选择" @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of resData.agencyTypeMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <div class="title">大区</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.areaCompany" size='mini' placeholder="请选择"
                     @change='handleAreaCompanyIdChange'>
            <el-option
              v-for="(val, key, i) of resData.areaCompanyMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="title">市场类型</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.marketType" size='mini' placeholder="请选择" @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of resData.marketTypeMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <div class="title">省区</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.provinceBranchCompany" size='mini' placeholder="请选择"
                     @click.native='provinceBranchCompanyClick' @change='handleDealerCompanyChange'>
            <el-option
              v-for="(val, key, i) of provinceBranchCompanyMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="title">门店</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.store" size='mini' placeholder="请选择" @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of resData.storeMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <div class="title">冷柜系列</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.productModelType" size='mini' placeholder="请选择"
                     @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of resData.productModelTypeSet"
              :key="val"
              :label="val"
              :value="val">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="title">省</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.provinceCode" size='mini' placeholder="请选择"
                     @change='handleProvinceCodeChange'>
            <el-option
              :key="key"
              v-for="(val, key, i) of resData.provinceMap"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <div class="title">一级渠道</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.channelType" size='mini' placeholder="请选择"
                     @change='handleChannelTypeChange'>
            <el-option
              v-for="(val, key, i) of resData.channelTypeMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="title">市</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.cityCode" size='mini' placeholder="请选择"
                     @click.native='handleCityCodeClick' @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of cityMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <div class="title">二级渠道</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.secondChannelType" size='mini' placeholder="请选择"
                     @click.native='handleSecondChannelTypeClick' @change='handleSecondChannelTypeChange'>
            <el-option
              v-for="(val, key, i) of secondChannelTypeMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="title">投放政策</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.putPolicy" size='mini' placeholder="请选择" @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of resData.putPolicyMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <div class="title">三级渠道</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.thirdChannelType" size='mini' placeholder="请选择"
                     @click.native='handleThirdChannelTypeClick' @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of thirdChannelTypeMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="title">经销商</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.dealerCompany" size='mini' placeholder="请选择" @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of dealerCompanyMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <div class="title">资产号</div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-select clearable v-model="params.assetsNum" size='mini' placeholder="请选择" @change='handleGroupChange'>
            <el-option
              v-for="(val, key, i) of resData.assetsMap"
              :key="key"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
    export default {
        name: 'DialogBox',
        props: {
            selectOjb: Object,
            labelNames: Object
        },
        data() {
            return {
                params: this.selectOjb,
                postParams: {
                    type: 'groupId'
                },
                resData: {},
                cityMap: [],
                secondChannelTypeMap: [],
                thirdChannelTypeMap: [],
                dealerCompanyMap: [],
                assetsMap: [],
                provinceBranchCompanyMap: [],
                labels: this.labelNames
            }
        },
        mounted() {
            this.getOptions();
        },
        methods: {
            getLabel() {
                debugger;
                let obj = this.params;
                let names = this.resData;
                let labelobj = this.labels;
                console.log(labelobj);
                for (let key in obj) {
                    if (key.indexOf("secondChannelType") == 0) {
                        labelobj[key] = this.secondChannelTypeMap[obj[key]];
                    } else if (key.indexOf("thirdChannelType") == 0) {
                        labelobj[key] = this.thirdChannelTypeMap[obj[key]];
                    } else if (key.indexOf("dealerCompany") == 0) {
                        labelobj[key] = this.dealerCompanyMap[obj[key]];
                    } else if (key.indexOf("provinceBranchCompany") == 0) {
                        labelobj[key] = this.provinceBranchCompanyMap[obj[key]];
                    } else if (key.indexOf("city") == 0) {
                        labelobj[key] = this.cityMap[obj[key]];
                    } else if (key.indexOf("provinceCode") == 0) {
                        labelobj[key] = this.resData.provinceMap[obj[key]];
                    } else if (key.indexOf("assetsNum") == 0) {
                        labelobj[key] = this.resData.assetsMap[obj[key]];
                    } else if (obj[key]) {
                        for (let name in names) {
                            if (name.indexOf(key) == 0) {
                                labelobj[key] = names[name][obj[key]];
                            }
                        }
                    }
                }

                console.log(labelobj);
            },
            handleGroupChange(val) {
                this.getLabel();
                this.$emit('callFather', this.params)
            },
            handleAreaCompanyIdChange() {
                let _this = this;
                this.postParams = {
                    type: 'provinceBranchCompanyMap',
                    parentId: _this.params.areaCompany
                };
                this.params.provinceBranchCompany = '';
                this.params.dealerCompany = '';
                this.dealerCompanyMap = [];
                this.getOptions();
                this.getLabel();
                this.$emit('callFather', this.params)
            },
            provinceBranchCompanyClick() {
                if (this.params.areaCompany.length > 0) {
                    return;
                }
                this.$message({
                    message: '请选择大区！',
                    type: 'warning'
                });
            },
            handleDealerCompanyChange() {
                let _this = this;
                this.postParams = {
                    type: 'dealerCompanyMap',
                    parentId: _this.params.provinceBranchCompany
                };
                this.params.dealerCompany = '';
                this.getOptions();
                this.getLabel();
                this.$emit('callFather', this.params)
            },
            handleChannelTypeChange() {
                let _this = this;
                this.postParams = {
                    type: 'secondChannelTypeMap',
                    parentId: _this.params.channelType
                };
                this.params.secondChannelType = '';
                this.thirdChannelTypeMap = [];
                this.params.thirdChannelType = '';
                this.getOptions();
                this.getLabel();
                this.$emit('callFather', this.params)
            }
            ,
            handleSecondChannelTypeClick() {
                if (this.params.channelType.length > 0) {
                    return;
                }
                this.$message({
                    message: '请选择一级渠道！',
                    type: 'warning'
                });
            }
            ,
            handleSecondChannelTypeChange() {
                let _this = this;
                this.postParams = {
                    type: 'thirdChannelTypeMap',
                    parentId: _this.params.secondChannelType
                };
                this.params.thirdChannelType = '';
                this.getOptions();
                this.getLabel();
                this.$emit('callFather', this.params)
            }
            ,
            handleThirdChannelTypeClick() {
                if (this.params.secondChannelType.length > 0) {
                    return;
                }
                this.$message({
                    message: '请选择二级渠道！',
                    type: 'warning'
                });
            }
            ,
            handleProvinceCodeChange() {
                let _this = this;
                this.postParams = {
                    type: 'cityMap',
                    parentId: _this.params.provinceCode
                };
                this.params.cityCode = '';
                this.getOptions();
                this.getLabel();
                this.$emit('callFather', this.params)
            }
            ,
            handleCityCodeClick() {
                if (this.params.provinceCode.length > 0) {
                    return;
                }
                this.$message({
                    message: '请选择省！',
                    type: 'warning'
                });
            }
            ,
            getOptions() {
                this.$ajax.post('data/getBigDataIndex_dict', this.postParams)
                    .then(this.getOptionsSucc)
                    .catch(function (res) {
                        console.log(res)
                    })
            }
            ,
            getOptionsSucc(res) {
                const data = res.data;
                if (data && data.code === 200) {
                    switch (this.postParams.type) {
                        case 'groupId':
                            this.resData = data.data;
                            this.provinceBranchCompanyMap = {};
                            this.secondChannelTypeMap = {};
                            this.thirdChannelTypeMap = {};
                            this.cityMap = {};
                            break;
                        case "secondChannelTypeMap":
                            this.secondChannelTypeMap = data.data.secondChannelTypeMap;
                            break;
                        case "thirdChannelTypeMap":
                            this.thirdChannelTypeMap = data.data.thirdChannelTypeMap;
                            break;
                        case "provinceBranchCompanyMap":
                            this.provinceBranchCompanyMap = data.data.provinceBranchCompanyMap;
                            break;
                        case "dealerCompanyMap":
                            this.dealerCompanyMap = data.data.dealerCompanyMap;
                            break;
                        default:
                            this.cityMap = data.data.cityMap;
                    }
                }
            }
        }
    }
</script>
<style scoped>
  .dialog-window .el-row {
    padding: 5px 0;
  }

  .title {
    line-height: 27px;
    padding-right: 10px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/DialogBox.vue